export const DEPARTMENT_DELETE_DIALOG = {
  TITLE: 'Eliminar Departamento',
  QUESTION: '¿Estás seguro de que deseas eliminar',
  CONFIRMATION: 'Esta acción no se puede deshacer.',
  CANCEL: 'Cancelar',
  DELETE: 'Eliminar',
}

export const DEPARTMENT_MESSAGES = {
  DELETED: 'Departamento eliminado correctamente',
  CREATED: 'Departamento creado correctamente',
  CREATED_WITHOUT_MEMBERS: 'Departamento creado pero falló la asignación de miembros',
  CREATED_WITHOUT_SUPPLIERS: 'Departamento creado pero falló la asignación de proveedores',
  FAILED_TO_CREATE: 'Error al crear el departamento',
}

export const DEPARTMENTS = {
  TITLE: 'Departamentos',
  ADD_DEPARTMENT: 'Agregar Departamento',
  NO_DEPARTMENTS: 'Aún no se han creado departamentos.',
  MEMBERS: 'miembros',
  MEMBERS_COUNT: (count: number) => `Miembros (${count})`,
  NO_MEMBERS: 'Sin miembros',
  MORE_MEMBERS: 'más',
  DEPARTMENT_DETAILS: 'Detalles del Departamento',
  DEPARTMENT_NAME: 'Nombre del Departamento',
  NEW_DEPARTMENT: 'Nuevo Departamento',
  CREATE_DEPARTMENT: 'Crear Departamento',
  CANCEL: 'Cancelar',
  SELECT_MEMBERS: 'Seleccionar miembros...',
  ADD_MORE_MEMBERS: 'Agregar más miembros...',
  SEARCH_USERS: 'Buscar usuarios...',
  LOADING: 'Cargando...',
  NO_USERS_FOUND: 'No se encontraron usuarios',
  SUPPLIERS: 'proveedores',
  SUPPLIERS_COUNT: (count: number) => `Proveedores (${count})`,
  SELECT_SUPPLIERS: 'Seleccionar proveedores...',
  ADD_MORE_SUPPLIERS: 'Agregar más proveedores...',
  SEARCH_SUPPLIERS: 'Buscar proveedores...',
  NO_SUPPLIERS_FOUND: 'No se encontraron proveedores',
}

export const EMPLOYEE_DASHBOARD_TABS = {
  TITLE: 'Dashboard de Empleados',
  EMPLOYEES: 'Empleados',
}
